(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bd-cart-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bd-cart-delivery')) {
  customElements.define('bd-cart-delivery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.postcode = this.querySelector('[data-postcode]');
      this.state = this.querySelector('[data-state]');
      this.button = this.querySelector('[data-estimate]');
      this.status = this.querySelector('[role="status"]');
      this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
      this.events = new AbortController();
      const options = {signal:this.events.signal};
      this.button.addEventListener('click', () => this.estimate(), options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Enter' && event.target.matches('input, select')) {
          event.preventDefault();
          if (!this.button.disabled) this.estimate();
        }
      }, options);
      this.addEventListener('input', () => {
        this.request?.abort();
        this.request = null;
        this.button.disabled = false;
        this.status.textContent = '';
        this.status.removeAttribute('aria-busy');
        this.postcode.removeAttribute('aria-invalid');
        this.state.removeAttribute('aria-invalid');
      }, options);
      try {
        const saved = JSON.parse(sessionStorage.getItem('bd-cart-delivery-address'));
        if (saved) { this.postcode.value = saved.postcode || ''; this.state.value = saved.state || ''; }
      } catch {}
    }
    disconnectedCallback() {
      this.events?.abort();
      this.request?.abort();
      this.ready = false;
    }
    async estimate() {
      const postcode = this.postcode.value.trim();
      if (!/^[0-9]{4}$/.test(postcode)) {
        this.status.textContent = this.messages.postcode;
        this.postcode.setAttribute('aria-invalid','true');
        this.postcode.focus();
        return;
      }
      if (!this.state.value) {
        this.status.textContent = this.messages.state;
        this.state.setAttribute('aria-invalid','true');
        this.state.focus();
        return;
      }
      this.request?.abort();
      const request = this.request = new AbortController();
      const timeout = setTimeout(() => request.abort(), 25000);
      this.button.disabled = true;
      this.status.textContent = this.messages.loading;
      this.status.setAttribute('aria-busy','true');
      try {
        try { sessionStorage.setItem('bd-cart-delivery-address', JSON.stringify({postcode,state:this.state.value})); } catch {}
        const parameters = new URLSearchParams({'shipping_address[zip]':postcode,'shipping_address[country]':'Australia','shipping_address[province]':this.state.value});
        const base = this.dataset.cartUrl.replace(/\/$/,'');
        const init = {credentials:'same-origin',signal:request.signal,headers:{Accept:'application/json'}};
        const prepared = await fetch(`${base}/prepare_shipping_rates.json?${parameters}`, {...init,method:'POST'});
        if (!prepared.ok) throw new Error('prepare');
        let data = null;
        for (let attempt = 0; attempt < 10; attempt++) {
          if (attempt) await new Promise(resolve => setTimeout(resolve,1200));
          if (request.signal.aborted) throw new Error('cancelled');
          const response = await fetch(`${base}/async_shipping_rates.json?${parameters}`,{...init,cache:'no-store'});
          if (!response.ok) throw new Error('rates');
          data = await response.json();
          if (data !== null) break;
        }
        if (!this.isConnected || request !== this.request) return;
        if (!data || !Array.isArray(data.shipping_rates)) throw new Error('missing');
        this.status.replaceChildren();
        if (!data.shipping_rates.length) { this.status.textContent = this.messages.empty; return; }
        const title = document.createElement('strong');
        title.textContent = this.messages.title;
        const list = document.createElement('ul');
        for (const rate of data.shipping_rates) {
          const price = Number(rate.price);
          if (!Number.isFinite(price)) continue;
          const line = document.createElement('li');
          const label = document.createElement('span');
          const amount = document.createElement('strong');
          label.textContent = rate.presentment_name || rate.name;
          amount.textContent = price === 0 ? this.messages.free : new Intl.NumberFormat('en-AU',{style:'currency',currency:rate.currency || this.dataset.currency || 'AUD'}).format(price);
          line.append(label,amount);list.append(line);
        }
        if (!list.children.length) throw new Error('empty');
        this.status.append(title,list);
      } catch {
        if (this.isConnected && request === this.request) this.status.textContent = this.messages.error;
      } finally {
        clearTimeout(timeout);
        if (request === this.request) {
          this.button.disabled = false;
          this.status.removeAttribute('aria-busy');
        }
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-menu"] && !Shopify.designMode) return;
  try {
    (() => {
  function initMenuSizing() {
    const menu = document.querySelector('#mobile-menu.bd-mobile-menu');
    if (!menu || menu.dataset.sizingReady) return;
    menu.dataset.sizingReady = 'true';
    menu.querySelector('.bd-menu-bundle')?.addEventListener('click', () => {
      if (menu.getAttribute('aria-hidden') === 'false') menu.closest('.header__mobile-nav').querySelector('[data-action="toggle-menu"]')?.click();
    });
    const header = menu.closest('.header__inner');
    const size = () => {
      const viewport = window.visualViewport;
      const bottom = viewport ? viewport.height + viewport.offsetTop : window.innerHeight;
      menu.style.setProperty('--bd-menu-height', Math.max(180, bottom - header.getBoundingClientRect().bottom - 10) + 'px');
    };
    new MutationObserver(size).observe(menu, {attributes:true, attributeFilter:['aria-hidden']});
    new ResizeObserver(size).observe(header);
    window.addEventListener('resize',size,{passive:true});
    window.addEventListener('scroll',size,{passive:true});
    window.visualViewport?.addEventListener('resize',size,{passive:true});
    size();
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initMenuSizing); else initMenuSizing();
  document.addEventListener('shopify:section:load',initMenuSizing);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rever-product-videos"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-rb-videos]').forEach(section => {
      if (section.dataset.rbVideosReady) return;
      section.dataset.rbVideosReady = 'true';
      document.querySelectorAll('a[href="#rb-product-videos"]').forEach(link => {
        link.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          const header = document.querySelector('header.header');
          const offset = header ? header.getBoundingClientRect().height + 24 : 24;
          window.scrollTo({top:window.scrollY + section.getBoundingClientRect().top - offset,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
        });
      });
      const panels = [...section.querySelectorAll('[data-rb-video-panel]')];
      const buttons = [...section.querySelectorAll('[data-rb-video-select]')];
      const load = panel => panel?.querySelectorAll('iframe[data-rb-video-src]').forEach(frame => {if (!frame.getAttribute('src')) frame.src = frame.dataset.rbVideoSrc;});
      const choose = id => {
        panels.forEach(panel => {
          const active = panel.dataset.rbVideoPanel === id;
          if (!active) {
            panel.querySelectorAll('video').forEach(video => video.pause());
            panel.querySelectorAll('iframe[src]').forEach(frame => frame.removeAttribute('src'));
          }
          panel.hidden = !active;
          if (active) load(panel);
        });
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.rbVideoSelect === id)));
      };
      buttons.forEach(button => button.addEventListener('click', () => choose(button.dataset.rbVideoSelect)));
      const navigation = section.querySelector('[data-rb-video-navigation]');
      if (navigation) navigation.hidden = false;
      section.querySelectorAll('[data-rb-video-scroll]').forEach(button => button.addEventListener('click', () => {
        const rail = section.querySelector('.rb-videos-rail');
        rail.scrollBy({left:Number(button.dataset.rbVideoScroll) * Math.max(rail.clientWidth * .8,156),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      }));
      const observer = new IntersectionObserver(entries => {if(entries.some(entry => entry.isIntersecting)){load(panels.find(panel=>!panel.hidden));observer.disconnect();}}, {rootMargin:'150px'});
      observer.observe(section);
    });
  };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>initialise());else initialise();
  document.addEventListener('shopify:section:load',event=>initialise(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
